module.exports = __webpack_public_path__ + "static/media/ganeshs.f9872938.png";